/** H5 已实现移动端产品服务的 productKind */
export const H5_MOBILE_SUPPORTED_PRODUCT_KINDS = new Set(["viewpoint", "qa"]);

export function isH5MobileProductSupported(productKind: string | null | undefined): boolean {
  const kind = productKind?.trim().toLowerCase();
  return Boolean(kind && H5_MOBILE_SUPPORTED_PRODUCT_KINDS.has(kind));
}
